var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-badge',_vm._b({class:[_vm.$store.getters.dark ? 'dark' : ''],attrs:{"content":_vm.$attrs.content || _vm.$attrs.value,"color":_vm.$attrs.color || 'error',"offset-x":_vm.$attrs['offset-x'] || '0',"offset-y":_vm.$attrs['offset-y'] || '0'}},'v-badge',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }